<script setup>
import {computed, onMounted} from 'vue'
import { useWorksStore } from '@/stores/work.js'
import { useRoute } from 'vue-router'
import Split from '@/layouts/split.vue'
import Comments from '@/components/Comments.vue'
import DocList from '@/components/documents/DocList.vue'
import WorkDetails from "@/components/work/WorkDetails.vue";
import FilesList from "@/components/common/FilesList.vue";

const route = useRoute()
const worksStore = useWorksStore()
const work = computed(() => worksStore.work)

onMounted(() => {
  worksStore.loadWork(route.params.id);
});

const workId = route.params.id;
</script>

<template>
  <Split>
    <template #main>
      <WorkDetails :work-id="workId" />
      <div class="flex flex-col lg:flex-row gap-4 pt-4">
        <DocList target="work" :entity-id="Number(workId)" class="flex-1"/>
        <FilesList target="work" :entity-id="Number(workId)" class="flex-1"/>
      </div>
    </template>

    <template #sidebar>
      <Comments
          class="flex-1 min-h-0"
          target="work"
          :entity-id="route.params.id"
          :currentUserName="'Вы'"
      />
    </template>

  </Split>

</template>